var Ractive = require('ractive');
var component = module;

	component.exports = {
		onrender: function (options) {
			var self = this;

			if ((typeof (Global) == "object") && (Global.Config)) {
				if (Global.Config.LinkHelp) {
					this.set('LinkHelp', Global.Config.LinkHelp);
				}
				if (Global.Config.LinkManual) {
					this.set('LinkManual', Global.Config.LinkManual);
				}
			}

			self.on('doToggle', function (iIndex, iSubIndex) {
				let fMenu = self.get('CacheData.Menu');
				console.log(fMenu);
				if (fMenu && fMenu[iIndex] && fMenu[iIndex].Items && fMenu[iIndex].Items[iSubIndex]) {
					if (fMenu[iIndex].Items[iSubIndex].class) {
						fMenu[iIndex].Items[iSubIndex].class = "";
						fMenu[iIndex].Items[iSubIndex].style = "position: relative; left: 0px; top: 0px; margin-right: 0px; margin-left: 0px; transform: translate(120px, 398px); box-sizing: border-box; display: none;";
					} else {
						fMenu[iIndex].Items[iSubIndex].class = "open";
						fMenu[iIndex].Items[iSubIndex].style = "position: relative; left: 0px; top: 0px; margin: 0px; transform: translate(8px, 678px); box-sizing: border-box; display: block;";
					}
					self.set('CacheData.Menu', fMenu);
					console.log(fMenu);
				}				
			});			
			self.on('doRefresh', function (e) {
				self.cmd.Data(self, { Name: "Menu", Payload: {} }, function (oData) {
					if (oData) {
						if (oData.Status) {
							self.set("CacheData.Menu", oData.Data);
							var fMenuMeta = {};
							var fMenuMetaCount = 0;
							for (i = 0; i < oData.Data.length; i++) {
								for (j = 0; j < oData.Data[i].Items.length; j++) {
									fMenuMetaCount++;
									fMenuMeta[oData.Data[i].Items[j].UID] = {
										MenuCaption: oData.Data[i].Items[j].Caption,
										Caption: oData.Data[i].Items[j].Caption
									};
								}
							}
							if (fMenuMetaCount == 0) {
								self.set('NoData', true);
							} else {
								self.set('NoData', false);
							}
							Window.nteforms = fMenuMeta;
						} else {
							toastr.error("Error", oData.Error);
						}
					}
				});
			});
			self.fire('doRefresh');
			/*
			var tag1 = document.createElement("script");
			tag1.src = "/res/js/defaultmenu.min.js";
			document.getElementsByTagName("head")[0].appendChild(tag1);
			*/
		},
		data: function () {
			return {
				NoData: false,
				LinkHelp: "",
				LinkManual: "",
				CacheData: {
					Menu: {}
				},
				UrlLink: "",
				Lng: SiteLng,
				IsActive: function (iUrlLink, iLink, iDefault) {
					if (iUrlLink) {
						iUrlLink = iUrlLink.toLowerCase().trim().replace("#", "").replace("list/", "");
						if (iUrlLink == iLink.toLowerCase().trim()) {
							return 'active';
						}
					}
					else {
						if (iDefault) {
							return 'active';
						}
					}
					return '';
				},
				formatLinkHelp: function (iLink) {
					if (iLink) {
						let fData = Client.getClone(Global.Session);
						fData.source = 'app_session';

						return iLink + '?' + Client.getBase64(fData);
					}

					return '';
				}
			}
		}
	}

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"main-sidebar",t:13},{n:"id",f:"sidebar-scroll",t:13}],f:[{p:[2,2,49],t:7,e:"nav",m:[{n:"class",f:"main-menu-container nav nav-pills flex-column sub-open",t:13}],f:[{p:[3,3,121],t:7,e:"div",m:[{n:"class",f:"slide-left",t:13},{n:"id",f:"slide-left",t:13}],f:[{p:[4,4,166],t:7,e:"svg",m:[{n:"xmlns",f:"http://www.w3.org/2000/svg",t:13},{n:"fill",f:"#7b8191",t:13},{n:"width",f:"24",t:13},{n:"height",f:"24",t:13},{n:"viewBox",f:"0 0 24 24",t:13}],f:[{p:[5,5,270],t:7,e:"path",m:[{n:"d",f:"M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z",t:13}]}]}]}," ",{p:[8,3,382],t:7,e:"input",m:[{n:"id",f:"FilterFindWord",t:13},{n:"class",f:"form-control form-control-sm",t:13},{n:"type",f:"text",t:13},{n:"placeholder",f:"Traži...",t:13},{n:"aria-label",f:"Traži...",t:13},{n:"value",f:[{t:2,r:"FilterFindWord",p:[8,130,509]}],t:13}]}," ",{p:[9,3,532],t:7,e:"ul",m:[{n:"class",f:"main-menu",t:13}],f:[{t:4,f:[{p:[11,4,584],t:7,e:"li",m:[{n:"class",f:"slide__category",t:13}],f:[{p:[11,32,612],t:7,e:"span",m:[{n:"class",f:"category-name",t:13}],f:[{t:3,r:".Caption",p:[11,60,640]}]}]}," ",{t:4,f:[{t:4,f:[{p:[14,5,729],t:7,e:"li",m:[{n:"class",f:"slide",t:13}],f:[{p:[15,6,754],t:7,e:"a",m:[{n:"class",f:["side-menu__item ",{t:2,x:{r:["IsActive","UrlLink",".UID"],s:"_0(_1,_2)"},p:[15,32,780]}],t:13},{n:"href",f:[{t:2,x:{r:["format",".UID"],s:"_0.Href(\"list\",_1)"},p:[15,67,815]}],t:13}],f:[{t:3,r:".Caption",p:[15,98,846]}]}]}],n:50,x:{r:["format",".Items"],s:"_0.Count(_1)==0"},p:[13,5,691]},{t:4,n:51,f:[{p:[18,5,895],t:7,e:"li",m:[{n:"class",f:["slide has-sub ",{t:2,r:".class",p:[18,30,920]}],t:13}],f:[{p:[19,6,939],t:7,e:"a",m:[{n:"href",f:"javascript:void(0);",t:13},{n:"class",f:"side-menu__item",t:13},{n:"click",f:{x:{r:["@this","m","mi"],s:"[_0.fire(\"doToggle\",_1,_2)]"}},t:70}],f:[{p:[20,7,1042],t:7,e:"i",m:[{n:"class",f:"ri-arrow-right-s-line side-menu__angle",t:13}]}," ",{p:[21,7,1104],t:7,e:"span",m:[{n:"class",f:"side-menu__label",t:13}],f:[{t:3,r:".Caption",p:[21,38,1135]}]}]}," ",{p:[23,6,1174],t:7,e:"ul",m:[{n:"class",f:"slide-menu child1",t:13},{n:"style",f:[{t:2,r:".style",p:[23,43,1211]}],t:13}],f:[{p:[24,7,1231],t:7,e:"li",m:[{n:"class",f:"slide side-menu__label1",t:13}],f:[{p:[25,8,1276],t:7,e:"a",m:[{n:"href",f:"javascript:void(0)",t:13}],f:[{t:3,r:".Caption",p:[25,37,1305]}]}]}," ",{t:4,f:[{p:[28,7,1367],t:7,e:"li",m:[{n:"class",f:"slide",t:13}],f:[{p:[29,8,1394],t:7,e:"a",m:[{n:"class",f:["side-menu__item ",{t:2,x:{r:["IsActive","UrlLink",".UID"],s:"_0(_1,_2)"},p:[29,34,1420]}],t:13},{n:"href",f:[{t:2,x:{r:["format",".UID"],s:"_0.Href(\"list\",_1)"},p:[30,15,1464]}],t:13}],f:[{t:3,r:".Caption",p:[30,46,1495]}]}]}],i:"mi2",r:".Items",p:[27,7,1344]}]}]}],l:1}],i:"mi",r:".Items",p:[12,4,671]}],i:"m",r:"CacheData.Menu",p:[10,3,558]}]}," ",{p:[39,3,1607],t:7,e:"div",m:[{n:"class",f:"slide-right",t:13},{n:"id",f:"slide-right",t:13}],f:[{p:[40,4,1654],t:7,e:"svg",m:[{n:"xmlns",f:"http://www.w3.org/2000/svg",t:13},{n:"fill",f:"#7b8191",t:13},{n:"width",f:"24",t:13},{n:"height",f:"24",t:13},{n:"viewBox",f:"0 0 24 24",t:13}],f:[{p:[41,5,1758],t:7,e:"path",m:[{n:"d",f:"M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z",t:13}]}]}]}]}]}],e:{"_0(_1,_2)":function (_0,_1,_2){return(_0(_1,_2));},"_0.Href(\"list\",_1)":function (_0,_1){return(_0.Href("list",_1));},"_0.Count(_1)==0":function (_0,_1){return(_0.Count(_1)==0);},"[_0.fire(\"doToggle\",_1,_2)]":function (_0,_1,_2){return([_0.fire("doToggle",_1,_2)]);}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Part/MenuLeft.html
// module id = 34
// module chunks = 0